import { useQuery } from '@tanstack/react-query';

import { api } from '../../../lib/api-client';

import type { DualApprovalRequestRaw } from '../../supervisor/types';

/** Status do ciclo de aprovação dupla onde o pedido ainda está aguardando resposta.
 *  R15 — schema.prisma: pending_first | pending_second (snake_case). */
const PENDING_STATUSES = new Set(['pending_first', 'pending_second']);

/** Envios do próprio operador aguardando aprovação (1ª/2ª). `enabled` gateia o
 *  fetch (regulated ∧ cap) — sem a flag, a query nem dispara. Regulated-only, leve. */
export function useMyPendingApprovals(enabled: boolean): {
  items: DualApprovalRequestRaw[];
  isLoading: boolean;
} {
  const q = useQuery({
    queryKey: ['dual-approval', 'requested-by-me'],
    queryFn: () => api.myRequestedDualApprovals(),
    enabled,
    staleTime: 30_000,
  });
  const items = (q.data?.items ?? []).filter((r) => PENDING_STATUSES.has(r.status));
  return { items, isLoading: q.isLoading };
}
